import { graphql } from "gql";

const GET_ORGANIZATION_GROUPS = graphql(`
  query GetOrganizationGroups(
    $after: String
    $filters: GroupsFiltersInput
    $first: Int!
    $organizationId: String!
    $sortBy: GroupsSortInput
  ) {
    organization(organizationId: $organizationId) {
      name
      groupsConnection(
        after: $after
        filters: $filters
        first: $first
        sortBy: $sortBy
      ) {
        totalCount
        edges {
          node {
            closedVulnerabilities
            description
            hasAdvanced
            hasEssential
            managed
            name
            openFindings
            openVulnerabilities
            service
            specifyEvaluationStage
            stakeholderRole
            subscription
            targetEvaluationStage
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      trial {
        completed
        extensionDate
        extensionDays
        startDate
        state
      }
    }
  }
`);

const GET_ORGANIZATION_ROOTS = graphql(`
  query GetOrganizationRoots(
    $after: String
    $first: Int!
    $organizationId: String!
  ) {
    organization(organizationId: $organizationId) {
      name
      groupsConnection(after: $after, first: $first) {
        edges {
          node {
            name
            roots {
              ... on GitRoot {
                cloningStatus {
                  status
                }
                machineStatus {
                  modifiedDate
                  status
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

const GET_ORGANIZATION_EVENTS = graphql(`
  query GetOrgEvents($after: String, $first: Int!, $organizationId: String!) {
    organization(organizationId: $organizationId) {
      name
      groupsConnection(after: $after, first: $first) {
        edges {
          node {
            name
            events(paginate: false) {
              edges {
                node {
                  id
                  eventStatus
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

const GET_ORGANIZATION_SECURITY_SUMMARY = graphql(`
  query GetOrganizationSecuritySummary($organizationId: String!) {
    organization(organizationId: $organizationId) {
      name
      securitySummary {
        attackSurface {
          coveragePercentage
          coveredRepositories
          hasOAuthCredentials
          outOfScopeRepositories
          totalRepositories
        }
        vulnerabilities {
          totalCvssf
          totalFindings
          totalVulnerabilities
          bySeverity {
            critical
            high
            low
            medium
          }
        }
      }
    }
  }
`);

export {
  GET_ORGANIZATION_GROUPS,
  GET_ORGANIZATION_ROOTS,
  GET_ORGANIZATION_EVENTS,
  GET_ORGANIZATION_SECURITY_SUMMARY,
};
